export const darkTheme = {
    bg:"#0A091A", // Midnight Blue-Violet
    bgLight: "#14122D", // Lighter variant for sections
    primary:"#9D50FF", // Vibrant Purple
    text_primary:"#F5F5FF", // Off-white
    text_secondary:"#8581B0", // Soft grayish purple
    card:"#14122D",
    card_light: '#1B1838',
    button:"#9D50FF",
    white:"#FFFFFF",
    black:"#0A091A", // Non-pure black
    glass_border: "rgba(157, 80, 255, 0.25)",
    soft2: "#8581B0",
}

export const lightTheme = {
    bg:"#FFFFFF",
    bgLight: "#f0f0f0",
    primary:"#be1adb",
    text_primary:"#111111",
    text_secondary:"#48494a",
    card:"#FFFFFF",
    card_light: '#f5f5f5',
    button:"#5c5b5b",
    glass_border: "rgba(190, 26, 219, 0.25)",
    soft2: "#6b7280",
}